import React, { useState } from 'react';
import aboutENImg from '@/static/about/aboutus-EN.png';
import aboutCNImg from '@/static/about/aboutus-CN.png';
import Header from '@/components/header';
import style from './index.module.css';

function HomePage() {

  const [curLangLabel, setLang] = useState('english');

  function onChangeLang(type:any) {
    setLang(type);
  }

  return (
    <div className={style.homePage}>
      <Header changeLang={onChangeLang}/>
      <div className={style.container}>
        {
          curLangLabel === 'english'
          ? <img src={aboutENImg} alt={''} className={style.imgItem}/>
          : <img src={aboutCNImg} alt={''} className={style.imgItem}/>
        }
      </div>
    </div>
  );
}

export default HomePage;
